module.exports = __webpack_public_path__ + "img/4C.2cdb3cfe.png";